import React, { useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { StyledPageTitle } from 'theme/styles';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { ERouteLinks } from 'models/route';
import { useNavigate, useParams } from 'react-router-dom';
import { ILicenceAuthorityPrintoutSettingsFormValues } from 'models/licenceAuthority';
import { initialPrintoutSettingsFormValues } from '../helpers';
import { useLicenceAuthorities } from '../hooks';
import LicenceAuthoritiesPrintoutSettingsForm from '../LicenceAuthoritiesPrintoutSettingsForm';

const LicenceAuthoritiesPrintoutSettingsAdd = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { id = '' } = useParams<{ id: string }>();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const { editPrintoutSettings } = useLicenceAuthorities();

  const onSubmit = async (data: ILicenceAuthorityPrintoutSettingsFormValues) => {
    setIsSubmitLoading(true);
    const res = await editPrintoutSettings(id, 0, data);
    if (res) {
      navigate(ERouteLinks.DetailsLicenceAuthorities.replace(':id', id));
    }
    setIsSubmitLoading(false);
  };

  const onCancel = () => navigate(ERouteLinks.DetailsLicenceAuthorities.replace(':id', id));

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t('module.administration.name'), route: ERouteLinks.Administration },
          { label: t('licenceAuthorities.header'), route: ERouteLinks.LicenceAuthorities },
          {
            label: t('licenceAuthorities.detailsLicenceAuthority.header'),
            route: ERouteLinks.DetailsLicenceAuthorities.replace(':id', id),
          },
          t('licenceAuthorities.addPrintoutSettings.header'),
        ]}
      />
      <StyledPageTitle variant="h4">
        {t('licenceAuthorities.addPrintoutSettings.header')}
      </StyledPageTitle>

      <LicenceAuthoritiesPrintoutSettingsForm
        onSubmit={onSubmit}
        isSubmitLoading={isSubmitLoading}
        initialFormValues={initialPrintoutSettingsFormValues}
        onCancel={onCancel}
      />
    </>
  );
};

export default LicenceAuthoritiesPrintoutSettingsAdd;
